import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  divider: {
    width: '93%'
  },
  fullWidth: {
    boxShadow: '0px 3px 14px #0000000F',
    borderRadius: 4,
    overflow: 'auto',
    margin: theme.spacing(2),
    maxWidth: 1500,
    width: '100%'
  },
  title: {
    fontFamily: theme.fonts.base,
    padding: theme.spacing(4),
    marginLeft: theme.spacing(2),
    color: theme.palette.common.black
  },
  details: {
    fontSize: 16,
    marginLeft: theme.spacing(6),
    color: theme.palette.text.grey,
    fontFamily: theme.fonts.openSans,
    padding: theme.spacing(1)
  },
  boxContainer: {
    padding: theme.spacing(4)
  },
  boxInner: {
    width: '45%',
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  statsTitle: {
    fontFamily: theme.fonts.openSans,
    color: '#7D7D7D',
    fontSize: 12
  },
  statsValue: {
    color: '#5C5C5C',
    fontSize: 16,
    fontFamily: theme.fonts.openSans
  },
  responsive: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  }
}));

export default useStyles;
